'use client'

import React from 'react'

import { DropdownMenu } from '@portal/taonga-ui'

import { css, cx } from '@news/styled-system/css'
import { useI18n } from '@/shared/providers'

import { AboutPageLink } from './about-page-link'
import { KnowledgeBaseLink } from './knowledge-base-link'
import { LegalInfo } from './legal-info'
import { SupportLink } from './support-link'

export function Dropdown({ children }: React.PropsWithChildren) {
    const { i18n } = useI18n()

    return (
        <DropdownMenu
            trigger={
                <React.Fragment>
                    <i className="fa-solid fa-bars" />
                    &nbsp;{i18n.BUTTON_HAMBURGER_MENU}&nbsp;
                    <i className={cx('fa-solid fa-caret-down', css({ fontSize: 'xs' }))} />
                </React.Fragment>
            }
        >
            {children}
            {/* Suspense needed because AboutPageLink uses useLoggedIn() which calls React.use() with a Promise */}
            <React.Suspense>
                <AboutPageLink variant="dropdown" />
            </React.Suspense>
            <SupportLink variant="dropdown" />
            <KnowledgeBaseLink variant="dropdown" />
            <LegalInfo />
        </DropdownMenu>
    )
}
